module.exports = __webpack_public_path__ + "static/8-0ac789556d2861bef20b519b36da2fd3.jpg";